import React from 'react'
import CustomerInformation from './CustomerInformation'

export default function CustomerProfile() {
  return (
    <div>
      <CustomerInformation/>
    </div>
  )
}
